import Service from './service'
export var PushMessageType;
(function (PushMessageType) {
  PushMessageType["PUSH_ADDED"] = "PUSH_ADDED"
})(PushMessageType || (PushMessageType = {}))
export var ApiPushMessageType;
(function (ApiPushMessageType) {
  ApiPushMessageType["SYSTEM_PUSH_RESPONSE"] = "system.push.response"
  ApiPushMessageType["SYSTEM_PUSH_ADDED"] = "system.push.added"
  ApiPushMessageType["SYSTEM_PUSH_REQUEST"] = "system.push.request"
  ApiPushMessageType["SYSTEM_PUSH_NUMBER"] = "system.push.number"
})(ApiPushMessageType || (ApiPushMessageType = {}))
export var PushServiceStatus;
(function (PushServiceStatus) {
  PushServiceStatus["NOT_AVAILABLE"] = "NOT_AVAILABLE"
  PushServiceStatus["AVAILABLE"] = "AVAILABLE"
})(PushServiceStatus || (PushServiceStatus = {}))
/**
 * Сервис для работы с push-уведомлениями
 * @version 0.0.1
 * @since 2.0.0
 */
export default class PushService extends Service {
  constructor(messageChannel) {
    super(messageChannel)
    const messageHandler = (message) => {
      switch (message.type) {
        case ApiPushMessageType.SYSTEM_PUSH_RESPONSE:
          if (typeof message.response.del_pushes !== 'undefined') {
            this.resolve(this.waiters.delete, message.response.del_pushes)
          }
          else if (typeof message.response.status !== 'undefined') {
            this.resolve(this.waiters.status, message.response.status)
          }
          else if (typeof message.response.add_push !== 'undefined') {
            this.resolve(this.waiters.add, message.response.add_push)
          }
          break
        case ApiPushMessageType.SYSTEM_PUSH_ADDED:
          delete message.id
          delete message.type
          this.broadcast(PushMessageType.PUSH_ADDED, message)
          break
        case ApiPushMessageType.SYSTEM_PUSH_NUMBER:
          //   if (this.onCountChangeCallback) {
          //     this.onAddedCallback(message.number);
          //   }
          break
      }
    }
    this.waiters = {
      add: [],
      delete: [],
      status: [],
    }
    this.messageChannel.subscribe(ApiPushMessageType.SYSTEM_PUSH_RESPONSE, messageHandler)
    this.messageChannel.subscribe(ApiPushMessageType.SYSTEM_PUSH_ADDED, messageHandler)
  }
  /**
     * push успешно добавлен
     *
     * @since 1.10.0
     * @param {(push: PushStructure) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof PushService
     *
     * @example <caption>push успешно добавлен</caption>
     * robot.pushService.onAdded((push) => {
     *   ...
     * })
     */
  onAdded(callback) {
    return this.subscribe(PushMessageType.PUSH_ADDED, callback)
  }
  /** @deprecated  */
  onCountChange(_callback) { }
  /**
     * Добавить push-сообщение
     *
     * Пуши разделяются на два типа: постоянные и временные. Временные скрываются по таймауту или по кнопке.
     * Для постоянных игнорируется таймаут и закрыть их можно  только послав другой важный с таким же тегом или
     * другой пуш с таким же отрицательным тегом. Используются только положительные теги, отрицательные считаются
     * закрывающими постоянные и, если закрывать нечего, игнорируются.
     *
     * @since 1.10.0
     * @param {PushStructure} push - структура push-сообщения
     * @return {*}  {Promise<boolean>}
     * @memberof PushService
     *
     * @example <caption>Добавить push-сообщение</caption>
     * robot.pushService.add(push).then((result) => {
     *   if (result) console.log("Push added")
     * })
     */
  add(push) {
    return this.execute({
      type: ApiPushMessageType.SYSTEM_PUSH_REQUEST,
      add_push: push
    }, this.waiters.add)
  }
  /**
     * Удалить push-сообщение
     *
     * @since 1.10.0
     * @param {PushDeleteOptions} [options={}] - параметры удаления
     * Удалять можно адресно по полю tag
     * Можно закрыть все временные, послав в поле force False
     * Можно закрыть все послав в поле force True
     *
     * @return {*}  {Promise<boolean>}
     * @memberof PushService
     *
     * @example <caption>Удалить push-сообщение</caption>
     * robot.pushService.add({force: false}).then((result) => {
     *   if (result) console.log("Push deleted")
     * })
     */
  delete(options = {}) {
    return this.execute({
      type: ApiPushMessageType.SYSTEM_PUSH_REQUEST,
      del_pushes: options,
    }, this.waiters.delete)
  }
  /**
     * Проверить доступность сервиса push-сообщений
     *
     * @since 1.10.0
     * @return {*}  {(Promise<PushServiceStatus | string>)}
     * @memberof PushService
     *
     * @example <caption>Проверить доступность сервиса push-сообщений</caption>
     * robot.pushService.status().then((status) => {
     *   if ...
     * })
     */
  status() {
    return this.execute({
      type: ApiPushMessageType.SYSTEM_PUSH_REQUEST,
      enable: {},
    }, this.waiters.status)
  }
  /**
     * Включить или выключить системный виджет push-сообщений
     * (если в рамках кейса планируется сделать
     * собственный обработчик и визуал для push-сообщений)
     *
     * @since 1.10.0
     * @param {boolean} status - желаемое состояние
     * @memberof PushService
     *
     * @example <caption>Включить или выключить системный виджет push-сообщений</caption>
     * robot.pushService.enableMainMenu(status)
     */
  enableMainMenu(status) {
    this.messageChannel.send({
      type: ApiPushMessageType.SYSTEM_PUSH_REQUEST,
      set_main_state: status,
    })
  }
}
